/**
 * This is a generated file,
 */

export const DESIGN_TOKENS_RAW = {
  borderRadius: {
    none: {
      enterprise: "0",
      consumer: "0",
    },
    sm: {
      enterprise: "0.25rem",
      consumer: "0.25rem",
      comment: "Use on inputs",
    },
    md: {
      enterprise: "0.5rem",
      consumer: "0.5rem",
      comment: "Use on cards and popovers",
    },
    lg: {
      enterprise: "1rem",
      consumer: "1rem",
      comment: "Use on modals",
    },
    xl: {
      enterprise: "1.5rem",
      consumer: "1.5rem",
      comment: "Use when extra rounded corners are needed",
    },
    round: {
      enterprise: "100rem",
      consumer: "100rem",
      comment: "Use to make elements pill shaped",
    },
  },
  breakpoint: {
    xs: {
      enterprise: "0em",
      consumer: "0em",
      comment: "Small devices such as phones. 0px and up.",
    },
    sm: {
      enterprise: "40em",
      consumer: "40em",
      comment: "Small tablets and phones in landscape. 640px and up.",
    },
    md: {
      enterprise: "48em",
      consumer: "48em",
      comment: "Average sized tablets. 768px and up.",
    },
    lg: {
      enterprise: "64em",
      consumer: "64em",
      comment: "Small laptops and large tablets. 1024px and up.",
    },
    xl: {
      enterprise: "80em",
      consumer: "80em",
      comment: "Average laptops and small monitors. 1280px and up.",
    },
    xl2: {
      enterprise: "90em",
      consumer: "90em",
      comment: "Large laptops and medium monitors. 1440px and up.",
    },
    xl3: {
      enterprise: "100em",
      consumer: "100em",
      comment: "Large laptops and large monitors. 1600px and up.",
    },
  },
  color: {
    primitive: {
      white: {
        enterprise: "#ffffff",
        consumer: "#ffffff",
      },
      black: {
        enterprise: "#05070a",
        consumer: "#000000",
      },
      gray: {
        "50": {
          enterprise: "#f0f1f4",
          consumer: "#fafafa",
        },
        "100": {
          enterprise: "#e0e3e8",
          consumer: "#f5f5f5",
        },
        "200": {
          enterprise: "#c1c7d1",
          consumer: "#eaeaea",
        },
        "300": {
          enterprise: "#a3acba",
          consumer: "#e1e1e1",
        },
        "400": {
          enterprise: "#8691a4",
          consumer: "#cbcbcb",
        },
        "500": {
          enterprise: "#5d6b83",
          consumer: "#b3b3b3",
        },
        "600": {
          enterprise: "#44546f",
          consumer: "#8e8e8e",
        },
        "700": {
          enterprise: "#303c50",
          consumer: "#6e6e6e",
        },
        "800": {
          enterprise: "#1D2634",
          consumer: "#4b4b4b",
        },
        "900": {
          enterprise: "#121823",
          consumer: "#2c2c2c",
        },
      },
      alphaBlack: {
        "50": {
          enterprise: "#0B0C0E0F",
          consumer: "rgba(0,0,0,0.03)",
        },
        "100": {
          enterprise: "#0C0E121F",
          consumer: "rgba(0,0,0,0.08)",
        },
        "200": {
          enterprise: "#0E11153D",
          consumer: "rgba(0,0,0,0.2)",
        },
        "300": {
          enterprise: "#14181F5E",
          consumer: "rgba(0,0,0,0.3)",
        },
        "400": {
          enterprise: "#14181F80",
          consumer: "rgba(0,0,0,0.4)",
        },
        "500": {
          enterprise: "#131820A1",
          consumer: "rgba(0,0,0,0.5)",
        },
        "600": {
          enterprise: "#11161DBA",
          consumer: "rgba(0,0,0,0.6)",
        },
        "700": {
          enterprise: "#11151DD6",
          consumer: "rgba(0,0,0,0.7)",
        },
        "800": {
          enterprise: "#0E131BE8",
          consumer: "rgba(0,0,0,0.8)",
        },
        "900": {
          enterprise: "#05070BED",
          consumer: "rgba(0,0,0,0.9)",
        },
      },
      alphaWhite: {
        "50": {
          enterprise: "#FCFCFDF7",
          consumer: "rgba(255,255,255,0.97)",
        },
        "100": {
          enterprise: "#F8F9FCE5",
          consumer: "rgba(255,255,255,0.92)",
        },
        "200": {
          enterprise: "#E1E6EFD9",
          consumer: "rgba(255,255,255,0.8)",
        },
        "300": {
          enterprise: "#CCD4E1CC",
          consumer: "rgba(255,255,255,0.7)",
        },
        "400": {
          enterprise: "#BBC9E2B2",
          consumer: "rgba(255,255,255,0.6)",
        },
        "500": {
          enterprise: "#B6C8E799",
          consumer: "rgba(255,255,255,0.5)",
        },
        "600": {
          enterprise: "#AFC9F373",
          consumer: "rgba(255,255,255,0.4)",
        },
        "700": {
          enterprise: "#B4CEF84D",
          consumer: "rgba(255,255,255,0.3)",
        },
        "800": {
          enterprise: "#A3C9F533",
          consumer: "rgba(255,255,255,0.2)",
        },
        "900": {
          enterprise: "#B7D3FA1A",
          consumer: "rgba(255,255,255,0.1)",
        },
      },
      yellow: {
        "50": {
          enterprise: "#fbefdd",
          consumer: "#fff9e6",
        },
        "100": {
          enterprise: "#f8dfbb",
          consumer: "#fff4cc",
        },
        "200": {
          enterprise: "#f6d39d",
          consumer: "#ffe99a",
        },
        "300": {
          enterprise: "#ffba2e",
          consumer: "#ffd84e",
        },
        "400": {
          enterprise: "#e59e00",
          consumer: "#ffc702",
        },
        "500": {
          enterprise: "#996706",
          consumer: "#dead00",
        },
        "600": {
          enterprise: "#6e4c07",
          consumer: "#a47f00",
        },
        "700": {
          enterprise: "#513604",
          consumer: "#634d00",
        },
        "800": {
          enterprise: "#352204",
          consumer: "#564300",
        },
        "900": {
          enterprise: "#1a0f01",
          consumer: "#2b2100",
        },
      },
      aqua: {
        "50": {
          enterprise: "#D0F8FE",
          consumer: "#e6fcff",
        },
        "100": {
          enterprise: "#90F1FF",
          consumer: "#ccfaff",
        },
        "200": {
          enterprise: "#00E5FF",
          consumer: "#b3f7ff",
        },
        "300": {
          enterprise: "#0DBCD1",
          consumer: "#80f2ff",
        },
        "400": {
          enterprise: "#0F9FB1",
          consumer: "#00e5ff",
        },
        "500": {
          enterprise: "#007685",
          consumer: "#00b7cc",
        },
        "600": {
          enterprise: "#025B66",
          consumer: "#008999",
        },
        "700": {
          enterprise: "#00424B",
          consumer: "#00454c",
        },
        "800": {
          enterprise: "#002B31",
          consumer: "#004c55",
        },
        "900": {
          enterprise: "#001418",
          consumer: "#00262a",
        },
      },
      pink: {
        "50": {
          enterprise: "#feedf1",
          consumer: "#fff5ff",
        },
        "100": {
          enterprise: "#ffd8e4",
          consumer: "#ffe8fe",
        },
        "200": {
          enterprise: "#feb1c8",
          consumer: "#ffd0fc",
        },
        "300": {
          enterprise: "#fe6798",
          consumer: "#ffbefc",
        },
        "400": {
          enterprise: "#ff007f",
          consumer: "#f78ff2",
        },
        "500": {
          enterprise: "#d10167",
          consumer: "#e04dd9",
        },
        "600": {
          enterprise: "#a40250",
          consumer: "#ba27b3",
        },
        "700": {
          enterprise: "#790239",
          consumer: "#840d7e",
        },
        "800": {
          enterprise: "#510224",
          consumer: "#671263",
        },
        "900": {
          enterprise: "#2a0110",
          consumer: "#330931",
        },
      },
      purple: {
        "50": {
          enterprise: "#f9edff",
          consumer: "#f8f8f8",
        },
        "100": {
          enterprise: "#efdbfb",
          consumer: "#f4eef5",
        },
        "200": {
          enterprise: "#e2b6fb",
          consumer: "#e5d5e8",
        },
        "300": {
          enterprise: "#d192f4",
          consumer: "#c9b2cd",
        },
        "400": {
          enterprise: "#c463f7",
          consumer: "#9e74a4",
        },
        "500": {
          enterprise: "#ad2be5",
          consumer: "#76507b",
        },
        "600": {
          enterprise: "#801faa",
          consumer: "#583c5c",
        },
        "700": {
          enterprise: "#5f1280",
          consumer: "#37253e",
        },
        "800": {
          enterprise: "#3e0a55",
          consumer: "#251929",
        },
        "900": {
          enterprise: "#1e052c",
          consumer: "#120c15",
        },
      },
      blue: {
        "50": {
          enterprise: "#eaf1fd",
          consumer: "#f6f9ff",
        },
        "100": {
          enterprise: "#d3e4ff",
          consumer: "#eaefff",
        },
        "200": {
          enterprise: "#a7c8ff",
          consumer: "#b0c3ff",
        },
        "300": {
          enterprise: "#7cabff",
          consumer: "#5982ff",
        },
        "400": {
          enterprise: "#528dff",
          consumer: "#3063ff",
        },
        "500": {
          enterprise: "#005BF5",
          consumer: "#0e3fd4",
        },
        "600": {
          enterprise: "#0548c1",
          consumer: "#01289f",
        },
        "700": {
          enterprise: "#00338d",
          consumer: "#001659",
        },
        "800": {
          enterprise: "#00225d",
          consumer: "#001965",
        },
        "900": {
          enterprise: "#000f29",
          consumer: "#000c32",
        },
      },
      green: {
        "50": {
          enterprise: "#eaf3ec",
          consumer: "#d8ffee",
        },
        "100": {
          enterprise: "#d4e7d9",
          consumer: "#a8f5d4",
        },
        "200": {
          enterprise: "#aacfb4",
          consumer: "#59e4a9",
        },
        "300": {
          enterprise: "#80b891",
          consumer: "#26db8d",
        },
        "400": {
          enterprise: "#55a06e",
          consumer: "#19bc76",
        },
        "500": {
          enterprise: "#078648",
          consumer: "#078648",
        },
        "600": {
          enterprise: "#075f31",
          consumer: "#016137",
        },
        "700": {
          enterprise: "#034523",
          consumer: "#013d23",
        },
        "800": {
          enterprise: "#022d14",
          consumer: "#03361d",
        },
        "900": {
          enterprise: "#001507",
          consumer: "#011b0e",
        },
      },
      orange: {
        "50": {
          enterprise: "#fdede7",
          consumer: "#ffeee7",
        },
        "100": {
          enterprise: "#ffdbce",
          consumer: "#ffddd0",
        },
        "200": {
          enterprise: "#ffb59c",
          consumer: "#ffccb8",
        },
        "300": {
          enterprise: "#ff784c",
          consumer: "#ff9971",
        },
        "400": {
          enterprise: "#ff5513",
          consumer: "#ff5512",
        },
        "500": {
          enterprise: "#c03d09",
          consumer: "#cc440e",
        },
        "600": {
          enterprise: "#972e05",
          consumer: "#99330b",
        },
        "700": {
          enterprise: "#701f02",
          consumer: "#662207",
        },
        "800": {
          enterprise: "#4b1200",
          consumer: "#5b1a00",
        },
        "900": {
          enterprise: "#260702",
          consumer: "#2d0d00",
        },
      },
      red: {
        "50": {
          enterprise: "#fdede9",
          consumer: "#ffefed",
        },
        "100": {
          enterprise: "#ffdad2",
          consumer: "#fed7d2",
        },
        "200": {
          enterprise: "#fcaea8",
          consumer: "#f1998e",
        },
        "300": {
          enterprise: "#f57460",
          consumer: "#e85c4a",
        },
        "400": {
          enterprise: "#ff3224",
          consumer: "#e11900",
        },
        "500": {
          enterprise: "#c71f0a",
          consumer: "#ab1300",
        },
        "600": {
          enterprise: "#a70c00",
          consumer: "#870f00",
        },
        "700": {
          enterprise: "#7c0500",
          consumer: "#5a0a00",
        },
        "800": {
          enterprise: "#540200",
          consumer: "#4b0800",
        },
        "900": {
          enterprise: "#2b0201",
          consumer: "#250400",
        },
      },
    },
    focusOutline: {
      enterprise: "#00225d",
      consumer: "#4b4b4b",
      light: {
        enterprise: "#d3e4ff",
        consumer: "#ffffff",
      },
    },
    button: {
      primary: {
        enterprise: "#005BF5",
        consumer: "#078648",
        comment: "Background of primary buttons",
        text: {
          enterprise: "#ffffff",
          consumer: "#ffffff",
          comment: "Accessible color on Primary Button",
        },
        hovered: {
          enterprise: "#0548c1",
          consumer: "#016137",
          comment: "Background of primary button hovered state",
        },
        pressed: {
          enterprise: "#00338d",
          consumer: "#013d23",
          comment: "Background of primary button pressed state",
        },
        focused: {
          enterprise: "#005BF5",
          consumer: "#016137",
          comment: "Background of primary button focused state",
        },
        disabled: {
          enterprise: "#0B0C0E0F",
          consumer: "#eaeaea",
          comment: "Background of primary button disabled state",
          text: {
            enterprise: "#131820A1",
            consumer: "#b3b3b3",
            comment: "Accessible color on primary button disabled state",
          },
        },
      },
      auxiliary: {
        enterprise: "#1D2634",
        consumer: "#000000",
        comment: "Background of auxiliary buttons",
        inverse: {
          enterprise: "#e0e3e8",
          consumer: "#ffffff",
        },
        text: {
          enterprise: "#ffffff",
          consumer: "#ffffff",
          comment: "Accessible color on auxiliary Button",
          inverse: {
            enterprise: "#1D2634",
            consumer: "#000000",
          },
        },
        hovered: {
          enterprise: "#303c50",
          consumer: "#2c2c2c",
          comment: "Background of auxiliary button hovered state",
          inverse: {
            enterprise: "#F8F9FCE5",
            consumer: "rgba(255,255,255,0.92)",
          },
        },
        pressed: {
          enterprise: "#44546f",
          consumer: "#4b4b4b",
          comment: "Background of auxiliary button pressed state",
          inverse: {
            enterprise: "#E1E6EFD9",
            consumer: "rgba(255,255,255,0.8)",
          },
        },
        focused: {
          enterprise: "#1D2634",
          consumer: "#000000",
          comment: "Background of auxiliary button focused state",
          inverse: {
            enterprise: "#e0e3e8",
            consumer: "#ffffff",
          },
        },
        disabled: {
          enterprise: "#0B0C0E0F",
          consumer: "rgba(0,0,0,0.03)",
          comment: "Background of auxiliary button pressed state",
          inverse: {
            enterprise: "#B7D3FA1A",
            consumer: "rgba(255,255,255,0.1)",
          },
          text: {
            enterprise: "#131820A1",
            consumer: "#b3b3b3",
            comment: "Accessible color on auxiliary button disabled state",
            inverse: {
              enterprise: "#BBC9E2B2",
              consumer: "rgba(255,255,255,0.6)",
            },
          },
        },
      },
      secondary: {
        enterprise: "#0C0E121F",
        consumer: "transparent",
        comment: "Background of secondary buttons",
        inverse: {
          enterprise: "#A3C9F533",
          consumer: "transparent",
          comment: "Dark mode secondary buttons",
        },
        border: {
          enterprise: "transparent",
          consumer: "#cbcbcb",
          comment: "Border of secondary buttons",
          inverse: {
            enterprise: "transparent",
            consumer: "transparent",
            comment: "Dark mode secondary button border",
          },
        },
        text: {
          enterprise: "#1D2634",
          consumer: "#2c2c2c",
          comment: "Accessible color on Secondary Button",
          inverse: {
            enterprise: "#F8F9FCE5",
            consumer: "#ffffff",
            comment: "Accessible color on Secondary Inverse Button",
          },
        },
        hovered: {
          enterprise: "#0E11153D",
          consumer: "#cbcbcb",
          comment: "Background of secondary button hovered state",
          inverse: {
            enterprise: "#B4CEF84D",
            consumer: "#4b4b4b",
            comment: "Background of dark mode secondary button hovered state",
          },
          border: {
            enterprise: "transparent",
            consumer: "#2c2c2c",
            comment: "Border of secondary button hovered state",
            inverse: {
              enterprise: "transparent",
              consumer: "#cbcbcb",
              comment: "Dark mode border of secondary button hovered state",
            },
          },
        },
        pressed: {
          enterprise: "#14181F5E",
          consumer: "#8e8e8e",
          comment: "Background of secondary button pressed state",
          inverse: {
            enterprise: "#AFC9F373",
            consumer: "#eaeaea",
            comment: "Background of dark mode secondary button pressed state",
          },
          border: {
            enterprise: "transparent",
            consumer: "transparent",
            comment: "Border of secondary button pressed state",
            inverse: {
              enterprise: "transparent",
              consumer: "transparent",
              comment: "Dark mode border of secondary button pressed state",
            },
          },
        },
        focused: {
          enterprise: "#0C0E121F",
          consumer: "#cbcbcb",
          comment: "Background of secondary button focused state",
          inverse: {
            enterprise: "#A3C9F533",
            consumer: "#4b4b4b",
            comment: "Dark mode secondary button focused state",
          },
          border: {
            enterprise: "transparent",
            consumer: "#2c2c2c",
            comment: "Border of secondary button focused state",
            inverse: {
              enterprise: "transparent",
              consumer: "#cbcbcb",
              comment: "Dark mode border of secondary button focused state",
            },
          },
        },
        disabled: {
          enterprise: "#0B0C0E0F",
          consumer: "transparent",
          comment: "Background of secondary button pressed state",
          inverse: {
            enterprise: "#B7D3FA1A",
            consumer: "transparent",
            comment: "Dark mode background of secondary button pressed state",
          },
          text: {
            enterprise: "#131820A1",
            consumer: "#b3b3b3",
            comment: "Accessible color on primary button disabled state",
            inverse: {
              enterprise: "#BBC9E2B2",
              consumer: "rgba(255,255,255,0.6)",
              comment:
                "Dark mode accessible color on primary button disabled state",
            },
          },
          border: {
            enterprise: "transparent",
            consumer: "transparent",
            comment: "Border of secondary button disabled state",
            inverse: {
              enterprise: "transparent",
              consumer: "transparent",
              comment: "Dark mode border of secondary button disabled state",
            },
          },
        },
      },
      tertiary: {
        enterprise: "transparent",
        consumer: "transparent",
        comment: "Background of tertiary buttons",
        text: {
          enterprise: "#005BF5",
          consumer: "#078648",
          comment: "Accessible color on tertiary Button",
        },
        hovered: {
          enterprise: "#eaf1fd",
          consumer: "rgba(0,0,0,0.03)",
          comment: "Background of tertiary button hovered state",
        },
        pressed: {
          enterprise: "#d3e4ff",
          consumer: "rgba(0,0,0,0.08)",
          comment: "Background of tertiary button pressed state",
        },
        focused: {
          enterprise: "transparent",
          consumer: "transparent",
          comment: "Background of tertiary button focused state",
        },
        disabled: {
          enterprise: "transparent",
          consumer: "transparent",
          comment: "Background of tertiary button pressed state",
          text: {
            enterprise: "#131820A1",
            consumer: "#b3b3b3",
            comment: "Accessible color on tertiary button disabled state",
          },
        },
      },
      subtle: {
        enterprise: "transparent",
        consumer: "transparent",
        comment: "Background of subtle buttons",
        inverse: {
          enterprise: "transparent",
          consumer: "transparent",
        },
        text: {
          enterprise: "#121823",
          consumer: "#2c2c2c",
          comment: "Accessible color on Subtle Button",
          inverse: {
            enterprise: "#F8F9FCE5",
            consumer: "#ffffff",
          },
        },
        hovered: {
          enterprise: "#0B0C0E0F",
          consumer: "rgba(0,0,0,0.03)",
          comment: "Background of subtle button hovered state",
          inverse: {
            enterprise: "#B7D3FA1A",
            consumer: "rgba(255,255,255,0.1)",
          },
        },
        pressed: {
          enterprise: "#0C0E121F",
          consumer: "rgba(0,0,0,0.08)",
          comment: "Background of subtle button pressed state",
          inverse: {
            enterprise: "#A3C9F533",
            consumer: "rgba(255,255,255,0.2)",
          },
        },
        focused: {
          enterprise: "transparent",
          consumer: "transparent",
          comment: "Background of subtle button focused state",
          inverse: {
            enterprise: "transparent",
            consumer: "transparent",
          },
        },
        disabled: {
          enterprise: "transparent",
          consumer: "rgba(0,0,0,0.03)",
          comment: "Background of subtle button pressed state",
          inverse: {
            enterprise: "transparent",
            consumer: "transparent",
          },
          text: {
            enterprise: "#131820A1",
            consumer: "#b3b3b3",
            comment: "Accessible color on subtle button disabled state",
            inverse: {
              enterprise: "#BBC9E2B2",
              consumer: "rgba(255,255,255,0.6)",
            },
          },
        },
      },
      warning: {
        enterprise: "#ffba2e",
        consumer: "#ffc702",
        comment: "Background of warning buttons",
        text: {
          enterprise: "#121823",
          consumer: "#2c2c2c",
          comment: "Accessible color on Warning Button",
        },
        hovered: {
          enterprise: "#e59e00",
          consumer: "#dead00",
          comment: "Background of warning button hovered state",
        },
        pressed: {
          enterprise: "#996706",
          consumer: "#dead00",
          comment: "Background of warning button pressed state",
        },
        focused: {
          enterprise: "#ffba2e",
          consumer: "#ffc702",
          comment: "Background of warning button focused state",
        },
        disabled: {
          enterprise: "#0B0C0E0F",
          consumer: "rgba(0,0,0,0.03)",
          comment: "Background of warning button pressed state",
          text: {
            enterprise: "#131820A1",
            consumer: "#b3b3b3",
            comment: "Accessible color on warning button disabled state",
          },
        },
      },
      critical: {
        enterprise: "#c71f0a",
        consumer: "#e11900",
        comment: "Background of critical buttons",
        text: {
          enterprise: "#ffffff",
          consumer: "#ffffff",
          comment: "Accessible color on Critical Button",
        },
        hovered: {
          enterprise: "#a70c00",
          consumer: "#ab1300",
          comment: "Background of critical button hovered state",
        },
        pressed: {
          enterprise: "#7c0500",
          consumer: "#870f00",
          comment: "Background of critical button pressed state",
        },
        focused: {
          enterprise: "#c71f0a",
          consumer: "#ab1300",
          comment: "Background of critical button focused state",
        },
        disabled: {
          enterprise: "#0B0C0E0F",
          consumer: "rgba(0,0,0,0.03)",
          comment: "Background of critical button pressed state",
          text: {
            enterprise: "#131820A1",
            consumer: "#b3b3b3",
            comment: "Accessible color on critical button disabled state",
          },
        },
      },
    },
    background: {
      primary: {
        enterprise: "#ffffff",
        consumer: "#ffffff",
        comment: "Background for pages and cards",
        inverse: {
          enterprise: "#1D2634",
          consumer: "#000000",
          comment: "Background for dark mode pages and cards",
        },
      },
      secondary: {
        enterprise: "#f0f1f4",
        consumer: "#fafafa",
        comment: "Alternative background for pages",
        inverse: {
          enterprise: "#121823",
          consumer: "#2c2c2c",
          comment: "Dark mode alternative background for pages",
        },
        alpha: {
          enterprise: "#0B0C0E0F",
          consumer: "rgba(0,0,0,0.03)",
          comment:
            "Use on elements whose background should darken the background it is already on, such as zebra striped tables and disabled inputs",
          inverse: {
            enterprise: "#B7D3FA1A",
            consumer: "rgba(255,255,255,0.1)",
            comment:
              "Dark mode for elements whose background should lighten the background it is already on, such as zebra striped tables and disabled inputs",
          },
        },
      },
      tertiary: {
        enterprise: "#e0e3e8",
        consumer: "#f5f5f5",
        comment:
          "Background for elements that need a differentiating background on top of Primary Background",
        inverse: {
          enterprise: "#1D2634",
          consumer: "#4b4b4b",
          comment:
            "Dark mode background for elements that need a differentiating background on top of Primary Background Inverse",
        },
        alpha: {
          enterprise: "#0C0E121F",
          consumer: "rgba(0,0,0,0.08)",
          comment:
            "Use on elements whose background should darken the background it is already on more than Background Secondary Alpha, such as chips and hover state for selectable elements",
          inverse: {
            enterprise: "#A3C9F533",
            consumer: "rgba(255,255,255,0.2)",
            comment:
              "Dark mode for elements whose background should lighten the background it is already on more than Background Secondary Alpha Inverse, such as chips and hover state for selectable elements",
          },
        },
      },
      selected: {
        enterprise: "#00225d",
        consumer: "#078648",
        comment: "Selected state background",
        inverse: {
          enterprise: "#528dff",
          consumer: "#3063ff",
          comment: "Dark mode selected state background",
        },
        light: {
          enterprise: "#eaf1fd",
          consumer: "rgba(0,0,0,0.08)",
          comment: "Subdued selected state background",
          inverse: {
            enterprise: "#0548c1",
            consumer: "#01289f",
            comment: "Dark mode subdued selected state background",
          },
        },
      },
      disabled: {
        enterprise: "#0B0C0E0F",
        consumer: "rgba(0,0,0,0.03)",
        comment: "Disabled state background",
        inverse: {
          enterprise: "#B7D3FA1A",
          consumer: "rgba(255,255,255,0.1)",
          comment: "Dark mode disabled state background",
        },
      },
      info: {
        enterprise: "#ad2be5",
        consumer: "#5982ff",
        comment: "Background for information elements",
        light: {
          enterprise: "#f9edff",
          consumer: "#f6f9ff",
          comment: "Subdued background for information elements",
          inverse: {
            enterprise: "#3e0a55",
            consumer: "#001965",
            comment: "Dark mode subdued background for information elements",
          },
        },
      },
      success: {
        enterprise: "#078648",
        consumer: "#19bc76",
        comment: "Background for success elements",
        light: {
          enterprise: "#eaf3ec",
          consumer: "#d8ffee",
          comment: "Subdued background for success elements",
          inverse: {
            enterprise: "#022d14",
            consumer: "#03361d",
            comment: "Dark mode subdued background for success elements",
          },
        },
      },
      warning: {
        enterprise: "#ffba2e",
        consumer: "#ffc702",
        comment: "Background for warning elements",
        light: {
          enterprise: "#fbefdd",
          consumer: "#fff9e6",
          comment: "Subdued background for warning elements",
          inverse: {
            enterprise: "#352204",
            consumer: "#564300",
            comment: "Dark mode subdued background for warning elements",
          },
        },
      },
      critical: {
        enterprise: "#c71f0a",
        consumer: "#e11900",
        comment: "Background for critical elements",
        light: {
          enterprise: "#fdede9",
          consumer: "#ffefed",
          comment: "Subdued background for critical elements",
          inverse: {
            enterprise: "#540200",
            consumer: "#4b0800",
            comment: "Dark mode subdued background for critical elements",
          },
        },
      },
      overlay: {
        enterprise: "#14181F80",
        consumer: "rgba(0,0,0,0.6)",
        comment: "Background for overlay elements",
      },
    },
    border: {
      normal: {
        enterprise: "#0E11153D",
        consumer: "#cbcbcb",
        comment: "Default border color",
        inverse: {
          enterprise: "#B4CEF84D",
          consumer: "rgba(255,255,255,0.3)",
          comment: "Dark mode default border color",
        },
      },
      light: {
        enterprise: "#0C0E121F",
        consumer: "rgba(0,0,0,0.08)",
        comment: "Subdued border color. Example: Thin lines in tables.",
        inverse: {
          enterprise: "#A3C9F533",
          consumer: "rgba(255,255,255,0.2)",
          comment: "Dark mode subdued border color",
        },
      },
      disabled: {
        enterprise: "#0B0C0E0F",
        consumer: "#f5f5f5",
        comment: "Disabled border color",
      },
      selected: {
        enterprise: "#005BF5",
        consumer: "#5982ff",
        comment: "Selected border color",
        light: {
          enterprise: "#a7c8ff",
          consumer: "#b0c3ff",
          comment: "Subdued border color",
        },
        inverse: {
          enterprise: "#528dff",
          consumer: "#3063ff",
          comment: "Dark mode selected border color",
        },
      },
      info: {
        enterprise: "#ad2be5",
        consumer: "#3063ff",
        comment: "Information border color",
        light: {
          enterprise: "#e2b6fb",
          consumer: "#b0c3ff",
          comment: "Subdued information border color",
          inverse: {
            enterprise: "#801faa",
            consumer: "#01289f",
            comment: "Dark mode subdued information border color",
          },
        },
      },
      success: {
        enterprise: "#078648",
        consumer: "#19bc76",
        comment: "Success border color",
        light: {
          enterprise: "#aacfb4",
          consumer: "#59e4a9",
          comment: "Subdued success border color",
          inverse: {
            enterprise: "#075f31",
            consumer: "#016137",
            comment: "Dark mode subdued success border color",
          },
        },
      },
      warning: {
        enterprise: "#ffba2e",
        consumer: "#ffc702",
        comment: "Warning border color",
        light: {
          enterprise: "#f6d39d",
          consumer: "#ffe99a",
          comment: "Subdued warning border color",
          inverse: {
            enterprise: "#6e4c07",
            consumer: "#a47f00",
            comment: "Dark mode subdued warning border color",
          },
        },
      },
      critical: {
        enterprise: "#c71f0a",
        consumer: "#e11900",
        comment: "Critical border color",
        light: {
          enterprise: "#fcaea8",
          consumer: "#f1998e",
          comment: "Subdued critical border color",
          inverse: {
            enterprise: "#a70c00",
            consumer: "#870f00",
            comment: "Dark mode subdued critical border color",
          },
        },
      },
    },
    brand: {
      DISQO: {
        enterprise: "#ff5512",
        consumer: "#ff5512",
        comment: "DISQO brand color",
      },
      SurveyJunkie: {
        enterprise: "#078648",
        consumer: "#078648",
        comment: "Survey Junkie brand color",
      },
    },
    dataViz: {
      categorical: {
        "1": {
          enterprise: "#00225d",
          consumer: "#3063ff",
        },
        "2": {
          enterprise: "#ff5513",
          consumer: "#37253e",
        },
        "3": {
          enterprise: "#ffba2e",
          consumer: "#ff5512",
        },
        "4": {
          enterprise: "#ff007f",
          consumer: "#ffc702",
        },
        "5": {
          enterprise: "#ad2be5",
          consumer: "#00e5ff",
        },
        "6": {
          enterprise: "#00E5FF",
          consumer: "#078648",
        },
        "7": {
          enterprise: "#078648",
          consumer: "#e04dd9",
        },
        "8": {
          enterprise: "#005BF5",
          consumer: "#00454c",
        },
        "9": {
          enterprise: "#034523",
          consumer: "#001659",
        },
        "10": {
          enterprise: "#5f1280",
          consumer: "#26db8d",
        },
        "11": {
          enterprise: "#a40250",
          consumer: "#662207",
        },
        "12": {
          enterprise: "#ff3224",
          consumer: "#671263",
        },
      },
      categoricalSubdued: {
        "1": {
          enterprise: "#a7c8ff",
          consumer: "#b0c3ff",
        },
        "2": {
          enterprise: "#ffb59c",
          consumer: "#c9b2cd",
        },
        "3": {
          enterprise: "#f6d39d",
          consumer: "#ffccb8",
        },
        "4": {
          enterprise: "#feb1c8",
          consumer: "#ffe99a",
        },
        "5": {
          enterprise: "#e2b6fb",
          consumer: "#b3f7ff",
        },
        "6": {
          enterprise: "#90F1FF",
          consumer: "#a8f5d4",
        },
      },
      likert: {
        "1": {
          enterprise: "#005BF5",
          consumer: "#3063ff",
        },
        "2": {
          enterprise: "#a7c8ff",
          consumer: "#00e5ff",
        },
        "3": {
          enterprise: "#f8dfbb",
          consumer: "#ffc702",
        },
        "4": {
          enterprise: "#fcaea8",
          consumer: "#ff5512",
        },
        "5": {
          enterprise: "#ff3224",
          consumer: "#ab1300",
        },
      },
      sequential: {
        "1": {
          enterprise: "#D0F8FE",
          consumer: "#e6fcff",
        },
        "2": {
          enterprise: "#9FF4FE",
          consumer: "#ccfaff",
        },
        "3": {
          enterprise: "#61EEFF",
          consumer: "#b3f7ff",
        },
        "4": {
          enterprise: "#00E5FF",
          consumer: "#80f2ff",
        },
        "5": {
          enterprise: "#00CFFD",
          consumer: "#00e5ff",
        },
        "6": {
          enterprise: "#00B8FC",
          consumer: "#05d8ff",
        },
        "7": {
          enterprise: "#00A2FA",
          consumer: "#0acbff",
        },
        "8": {
          enterprise: "#008BF8",
          consumer: "#13b1ff",
        },
        "9": {
          enterprise: "#0074F7",
          consumer: "#1d97ff",
        },
        "10": {
          enterprise: "#005BF5",
          consumer: "#267dff",
        },
        "11": {
          enterprise: "#004DD0",
          consumer: "#3063ff",
        },
        "12": {
          enterprise: "#0040AD",
          consumer: "#2652d6",
        },
        "13": {
          enterprise: "#00338A",
          consumer: "#1d40ad",
        },
        "14": {
          enterprise: "#002769",
          consumer: "#132f84",
        },
        "15": {
          enterprise: "#001B4A",
          consumer: "#0a1d5b",
        },
        "16": {
          enterprise: "#000F29",
          consumer: "#000c32",
        },
        gradient: {
          enterprise:
            "linear-gradient(90deg, #D0F8FE 0%, #00E5FF 25%, #005BF5 70%, #000f29 100%)",
          consumer:
            "linear-gradient(90deg, #e6fcff 0%, #00e5ff 25%, #0e3fd4 70%, #000c32 100%)",
        },
      },
    },
    text: {
      normal: {
        enterprise: "#1D2634",
        consumer: "#2c2c2c",
        comment: "Default text color",
        inverse: {
          enterprise: "#F8F9FCE5",
          consumer: "#ffffff",
          comment: "Dark mode default text color",
        },
      },
      title: {
        enterprise: "#303c50",
        consumer: "#2c2c2c",
        comment: "Default text color",
        inverse: {
          enterprise: "#E1E6EFD9",
          consumer: "#ffffff",
          comment: "Dark mode default text color",
        },
      },
      secondary: {
        enterprise: "#44546f",
        consumer: "#6e6e6e",
        comment: "Secondary text color",
        inverse: {
          enterprise: "#CCD4E1CC",
          consumer: "rgba(255,255,255,0.7)",
          comment: "Dark mode secondary text color",
        },
      },
      placeholder: {
        enterprise: "#5d6b83",
        consumer: "#8e8e8e",
        comment: "Accessible placeholder text color",
        inverse: {
          enterprise: "#BBC9E2B2",
          consumer: "rgba(255,255,255,0.6)",
          comment: "Dark mode accessible text color",
        },
      },
      disabled: {
        enterprise: "#131820A1",
        consumer: "#b3b3b3",
        comment: "Accessible disabled text color",
        inverse: {
          enterprise: "#BBC9E2B2",
          consumer: "rgba(255,255,255,0.6)",
          comment: "Dark mode accessible disabled text color",
        },
      },
      success: {
        enterprise: "#075f31",
        consumer: "#078648",
        comment: "Success text color",
        inverse: {
          enterprise: "#80b891",
          consumer: "#26db8d",
          comment: "Dark mode success color",
        },
      },
      warning: {
        enterprise: "#6e4c07",
        consumer: "#dead00",
        comment: "Warning text color",
        inverse: {
          enterprise: "#ffba2e",
          consumer: "#ffd84e",
          comment: "Dark mode warning text color",
        },
      },
      critical: {
        enterprise: "#a70c00",
        consumer: "#e11900",
        comment: "Critical text color",
        inverse: {
          enterprise: "#f57460",
          consumer: "#e85c4a",
          comment: "Dark mode critical text color",
        },
      },
      onSuccess: {
        enterprise: "#ffffff",
        consumer: "#ffffff",
        comment: "Accessible color on Success Background",
      },
      onWarning: {
        enterprise: "#1a0f01",
        consumer: "#2c2c2c",
        comment: "Accessible color on Warning Background",
      },
      onCritical: {
        enterprise: "#ffffff",
        consumer: "#ffffff",
        comment: "Accessible color on Critical Background",
      },
      onSelected: {
        enterprise: "#ffffff",
        consumer: "#ffffff",
        comment: "Accessible color on Selected Background",
        inverse: {
          enterprise: "#ffffff",
          consumer: "#ffffff",
          comment: "Accessible color on Selected Inverse Background",
        },
      },
      link: {
        enterprise: "#005BF5",
        consumer: "#3063ff",
        comment: "Link color",
        inverse: {
          enterprise: "#528dff",
          consumer: "#3063ff",
          comment: "Dark mode link color",
        },
        hovered: {
          enterprise: "#0548c1",
          consumer: "#0e3fd4",
          comment: "Hover state link color",
          inverse: {
            enterprise: "#7cabff",
            consumer: "#5982ff",
            comment: "Dark mode hover state link color",
          },
        },
        pressed: {
          enterprise: "#00338d",
          consumer: "#01289f",
          comment: "Pressed state link color",
          inverse: {
            enterprise: "#a7c8ff",
            consumer: "#b0c3ff",
            comment: "Dark mode pressed state link color",
          },
        },
        visited: {
          enterprise: "#5f1280",
          consumer: "#3063ff",
          comment: "Visited link color",
          inverse: {
            enterprise: "#c463f7",
            consumer: "#5982ff",
            comment: "Dark mode visited link color",
          },
        },
      },
    },
  },
  focus: {
    shadow: {
      enterprise: "0 0 0 2px #00225d, 0 0 0 6px #d3e4ff",
      consumer: "0 0 0 2px #ffffff, 0 0 0 4px #4b4b4b",
    },
  },
  shadow: {
    none: {
      enterprise: "none",
      consumer: "none",
      comment:
        "Used for when no shadow is needed. This token exists for components that support different shadows. It is not needed otherwise.",
    },
    xs: {
      enterprise: "0px 3px 6px 0px #0C0E121F, 0px 0px 4px 0px #0B0C0E0F",
      consumer:
        "0px 3px 6px 0px rgba(0,0,0,0.08), 0px 0px 4px 0px rgba(0,0,0,0.03)",
      comment: "Used for hover state of inputs.",
    },
    sm: {
      enterprise: "0px 5px 15px 0px #0C0E121F, 0px 2px 6px 0px #0B0C0E0F",
      consumer:
        "0px 5px 15px 0px rgba(0,0,0,0.08), 0px 2px 6px 0px rgba(0,0,0,0.03)",
      comment:
        "Used for cards in active state and other elements like popovers and tooltips.",
    },
    md: {
      enterprise:
        "0px 10px 25px 0px #0C0E121F, 0px 5px 15px 0px #0C0E121F, 0px 0px 6px 0px #0B0C0E0F",
      consumer:
        "0px 10px 25px 0px rgba(0,0,0,0.08), 0px 5px 15px 0px rgba(0,0,0,0.08), 0px 0px 6px 0px rgba(0,0,0,0.03)",
      comment: "Used for active dropdown menus.",
    },
    lg: {
      enterprise:
        "0px 0px 4px #0B0C0E0F, 0px 4px 16px #0C0E121F, 0px 25px 40px #0E11153D",
      consumer:
        "0px 25px 40px 0px rgba(0,0,0,0.2), 0px 0px 6px 0px rgba(0,0,0,0.03)",
      comment: "Used for dialogs and modals.",
    },
  },
  spacing: {
    "0": {
      enterprise: "0",
      consumer: "0",
      comment: "Used for no spacing.",
    },
    "1px": {
      enterprise: "1px",
      consumer: "1px",
      comment: "Used for slight nudge.",
    },
    "2px": {
      enterprise: "2px",
      consumer: "2px",
      comment: "Used for spacing within a component.",
    },
    "4px": {
      enterprise: "4px",
      consumer: "4px",
      comment: "Used for spacing within a component.",
    },
    xs: {
      enterprise: "0.5rem",
      consumer: "0.5rem",
      comment:
        "Used to separate related elements and for small padding or text and a related icon.",
    },
    sm: {
      enterprise: "0.75rem",
      consumer: "0.75rem",
      comment:
        "Used only for right and left padding of form elements and horizontal tabs",
    },
    md: {
      enterprise: "1rem",
      consumer: "1rem",
      comment:
        "Used to separate unrelated elements or groups and for normal padding.",
    },
    lg: {
      enterprise: "1.5rem",
      consumer: "1.5rem",
      comment: "Used to separate sub-sections of content.",
    },
    xl: {
      enterprise: "2rem",
      consumer: "2rem",
      comment: "Used to separate sections of content.",
    },
    "2xl": {
      enterprise: "3rem",
      consumer: "3rem",
      comment: "Used when more generous white space is needed.",
    },
    "3xl": {
      enterprise: "6rem",
      consumer: "6rem",
      comment: "Used when more extra generous white space is needed.",
    },
  },
  text: {
    primitives: {
      fontFamilies: {
        paragraph: {
          enterprise: "Poppins, sans-serif",
          consumer: "Poppins, sans-serif",
        },
        heading: {
          enterprise: "Poppins, sans-serif",
          consumer: "Poppins, sans-serif",
        },
        number: {
          enterprise:
            'ui-monospace, Menlo, Monaco, "Cascadia Mono", "Segoe UI Mono",  "Roboto Mono",  "Oxygen Mono",  "Ubuntu Monospace",  "Source Code Pro", "Fira Mono",  "Droid Sans Mono",  "Courier New", monospace',
          consumer: "Roboto, sans-serif",
        },
      },
      lineHeights: {
        none: {
          enterprise: "1",
          consumer: "1",
        },
        sm: {
          enterprise: "1.25",
          consumer: "1.25",
        },
        md: {
          enterprise: "1.5",
          consumer: "1.5",
        },
      },
      fontWeights: {
        regular: {
          enterprise: "500",
          consumer: "500",
        },
        bold: {
          enterprise: "700",
          consumer: "700",
        },
        black: {
          enterprise: "900",
          consumer: "800",
        },
      },
      fontSize: {
        "0": {
          enterprise: "1rem",
          consumer: "1rem",
        },
        "1": {
          enterprise: "1.25rem",
          consumer: "1.25rem",
        },
        "2": {
          enterprise: "1.5rem",
          consumer: "1.5rem",
        },
        "3": {
          enterprise: "2rem",
          consumer: "2rem",
        },
        "4": {
          enterprise: "2.5rem",
          consumer: "2.5rem",
        },
        "5": {
          enterprise: "3rem",
          consumer: "3rem",
        },
        "6": {
          enterprise: "4rem",
          consumer: "4rem",
        },
        "7": {
          enterprise: "4.75rem",
          consumer: "4.75rem",
        },
        "8": {
          enterprise: "6rem",
          consumer: "6rem",
        },
        "-2": {
          enterprise: "0.75rem",
          consumer: "0.75rem",
        },
        "-1": {
          enterprise: "0.875rem",
          consumer: "0.875rem",
        },
      },
      letterSpacing: {
        normal: {
          enterprise: "0",
          consumer: "0",
        },
        wide: {
          enterprise: "0.1em",
          consumer: "0.1em",
        },
      },
      paragraphSpacing: {
        "0": {
          enterprise: "0",
          consumer: "0",
        },
        "1": {
          enterprise: "1rem",
          consumer: "1rem",
        },
      },
    },
    display: {
      fontFamily: {
        enterprise: "Poppins, sans-serif",
        consumer: "Poppins, sans-serif",
      },
      fontWeight: {
        enterprise: "700",
        consumer: "800",
      },
      lineHeight: {
        enterprise: "1.25",
        consumer: "1.25",
      },
      paragraphSpacing: {
        enterprise: "0",
        consumer: "0",
      },
      lg: {
        enterprise: "6rem",
        consumer: "6rem",
      },
      md: {
        enterprise: "4.75rem",
        consumer: "4.75rem",
      },
      sm: {
        enterprise: "4rem",
        consumer: "4rem",
      },
      xs: {
        enterprise: "3rem",
        consumer: "3rem",
      },
    },
    headline: {
      fontFamily: {
        enterprise: "Poppins, sans-serif",
        consumer: "Poppins, sans-serif",
      },
      fontWeight: {
        enterprise: "700",
        consumer: "700",
      },
      lineHeight: {
        enterprise: "1.25",
        consumer: "1.25",
      },
      paragraphSpacing: {
        enterprise: "0",
        consumer: "0",
      },
      xl: {
        enterprise: "2.5rem",
        consumer: "2.5rem",
      },
      lg: {
        enterprise: "2rem",
        consumer: "2rem",
      },
      md: {
        enterprise: "1.5rem",
        consumer: "1.5rem",
      },
      sm: {
        enterprise: "1.25rem",
        consumer: "1.25rem",
      },
      xs: {
        enterprise: "1rem",
        consumer: "1rem",
      },
    },
    label: {
      fontFamily: {
        enterprise: "Poppins, sans-serif",
        consumer: "Poppins, sans-serif",
      },
      fontWeight: {
        enterprise: "500",
        consumer: "500",
      },
      lineHeight: {
        enterprise: "1.25",
        consumer: "1.25",
      },
      paragraphSpacing: {
        enterprise: "0",
        consumer: "0",
      },
      lg: {
        enterprise: "1.25rem",
        consumer: "1.25rem",
      },
      md: {
        enterprise: "1rem",
        consumer: "1rem",
      },
      sm: {
        enterprise: "0.875rem",
        consumer: "0.875rem",
      },
      uppercase: {
        letterSpacing: {
          enterprise: "0.1em",
          consumer: "0.1em",
        },
        textCase: {
          enterprise: "uppercase",
          consumer: "uppercase",
        },
      },
    },
    paragraph: {
      fontFamily: {
        enterprise: "Poppins, sans-serif",
        consumer: "Poppins, sans-serif",
      },
      fontWeight: {
        enterprise: "500",
        consumer: "500",
      },
      lineHeight: {
        enterprise: "1.5",
        consumer: "1.5",
      },
      paragraphSpacing: {
        enterprise: "0",
        consumer: "0",
      },
      lg: {
        enterprise: "1.25rem",
        consumer: "1.25rem",
      },
      md: {
        enterprise: "1rem",
        consumer: "1rem",
      },
      sm: {
        enterprise: "0.875rem",
        consumer: "0.875rem",
      },
    },
    bold: {
      fontWeight: {
        enterprise: "700",
        consumer: "700",
      },
    },
    number: {
      fontFamily: {
        enterprise:
          'ui-monospace, Menlo, Monaco, "Cascadia Mono", "Segoe UI Mono",  "Roboto Mono",  "Oxygen Mono",  "Ubuntu Monospace",  "Source Code Pro", "Fira Mono",  "Droid Sans Mono",  "Courier New", monospace',
        consumer: "Roboto, sans-serif",
      },
    },
  },
  zIndex: {
    modal: {
      enterprise: "800",
      consumer: "800",
      comment: "Used for modals.",
    },
    dropdown: {
      enterprise: "900",
      consumer: "900",
      comment: "Used for dropdowns.",
    },
    toast: {
      enterprise: "1000",
      consumer: "1000",
      comment: "Used for toast notifications.",
    },
    tooltip: {
      enterprise: "1100",
      consumer: "1100",
      comment: "Used for tooltips.",
    },
  },
};

export const DESIGN_TOKENS = {
  borderRadius: {
    none: {
      value: "var(--borderRadius-none)",
    },
    sm: {
      comment: "Use on inputs",
      value: "var(--borderRadius-sm)",
    },
    md: {
      comment: "Use on cards and popovers",
      value: "var(--borderRadius-md)",
    },
    lg: {
      comment: "Use on modals",
      value: "var(--borderRadius-lg)",
    },
    xl: {
      comment: "Use when extra rounded corners are needed",
      value: "var(--borderRadius-xl)",
    },
    round: {
      comment: "Use to make elements pill shaped",
      value: "var(--borderRadius-round)",
    },
  },
  breakpoint: {
    xs: {
      comment: "Small devices such as phones. 0px and up.",
      value: "var(--breakpoint-xs)",
    },
    sm: {
      comment: "Small tablets and phones in landscape. 640px and up.",
      value: "var(--breakpoint-sm)",
    },
    md: {
      comment: "Average sized tablets. 768px and up.",
      value: "var(--breakpoint-md)",
    },
    lg: {
      comment: "Small laptops and large tablets. 1024px and up.",
      value: "var(--breakpoint-lg)",
    },
    xl: {
      comment: "Average laptops and small monitors. 1280px and up.",
      value: "var(--breakpoint-xl)",
    },
    xl2: {
      comment: "Large laptops and medium monitors. 1440px and up.",
      value: "var(--breakpoint-xl2)",
    },
    xl3: {
      comment: "Large laptops and large monitors. 1600px and up.",
      value: "var(--breakpoint-xl3)",
    },
  },
  color: {
    primitive: {
      white: {
        value: "var(--color-primitive-white)",
      },
      black: {
        value: "var(--color-primitive-black)",
      },
      gray: {
        "50": {
          value: "var(--color-primitive-gray-50)",
        },
        "100": {
          value: "var(--color-primitive-gray-100)",
        },
        "200": {
          value: "var(--color-primitive-gray-200)",
        },
        "300": {
          value: "var(--color-primitive-gray-300)",
        },
        "400": {
          value: "var(--color-primitive-gray-400)",
        },
        "500": {
          value: "var(--color-primitive-gray-500)",
        },
        "600": {
          value: "var(--color-primitive-gray-600)",
        },
        "700": {
          value: "var(--color-primitive-gray-700)",
        },
        "800": {
          value: "var(--color-primitive-gray-800)",
        },
        "900": {
          value: "var(--color-primitive-gray-900)",
        },
      },
      alphaBlack: {
        "50": {
          value: "var(--color-primitive-alphaBlack-50)",
        },
        "100": {
          value: "var(--color-primitive-alphaBlack-100)",
        },
        "200": {
          value: "var(--color-primitive-alphaBlack-200)",
        },
        "300": {
          value: "var(--color-primitive-alphaBlack-300)",
        },
        "400": {
          value: "var(--color-primitive-alphaBlack-400)",
        },
        "500": {
          value: "var(--color-primitive-alphaBlack-500)",
        },
        "600": {
          value: "var(--color-primitive-alphaBlack-600)",
        },
        "700": {
          value: "var(--color-primitive-alphaBlack-700)",
        },
        "800": {
          value: "var(--color-primitive-alphaBlack-800)",
        },
        "900": {
          value: "var(--color-primitive-alphaBlack-900)",
        },
      },
      alphaWhite: {
        "50": {
          value: "var(--color-primitive-alphaWhite-50)",
        },
        "100": {
          value: "var(--color-primitive-alphaWhite-100)",
        },
        "200": {
          value: "var(--color-primitive-alphaWhite-200)",
        },
        "300": {
          value: "var(--color-primitive-alphaWhite-300)",
        },
        "400": {
          value: "var(--color-primitive-alphaWhite-400)",
        },
        "500": {
          value: "var(--color-primitive-alphaWhite-500)",
        },
        "600": {
          value: "var(--color-primitive-alphaWhite-600)",
        },
        "700": {
          value: "var(--color-primitive-alphaWhite-700)",
        },
        "800": {
          value: "var(--color-primitive-alphaWhite-800)",
        },
        "900": {
          value: "var(--color-primitive-alphaWhite-900)",
        },
      },
      yellow: {
        "50": {
          value: "var(--color-primitive-yellow-50)",
        },
        "100": {
          value: "var(--color-primitive-yellow-100)",
        },
        "200": {
          value: "var(--color-primitive-yellow-200)",
        },
        "300": {
          value: "var(--color-primitive-yellow-300)",
        },
        "400": {
          value: "var(--color-primitive-yellow-400)",
        },
        "500": {
          value: "var(--color-primitive-yellow-500)",
        },
        "600": {
          value: "var(--color-primitive-yellow-600)",
        },
        "700": {
          value: "var(--color-primitive-yellow-700)",
        },
        "800": {
          value: "var(--color-primitive-yellow-800)",
        },
        "900": {
          value: "var(--color-primitive-yellow-900)",
        },
      },
      aqua: {
        "50": {
          value: "var(--color-primitive-aqua-50)",
        },
        "100": {
          value: "var(--color-primitive-aqua-100)",
        },
        "200": {
          value: "var(--color-primitive-aqua-200)",
        },
        "300": {
          value: "var(--color-primitive-aqua-300)",
        },
        "400": {
          value: "var(--color-primitive-aqua-400)",
        },
        "500": {
          value: "var(--color-primitive-aqua-500)",
        },
        "600": {
          value: "var(--color-primitive-aqua-600)",
        },
        "700": {
          value: "var(--color-primitive-aqua-700)",
        },
        "800": {
          value: "var(--color-primitive-aqua-800)",
        },
        "900": {
          value: "var(--color-primitive-aqua-900)",
        },
      },
      pink: {
        "50": {
          value: "var(--color-primitive-pink-50)",
        },
        "100": {
          value: "var(--color-primitive-pink-100)",
        },
        "200": {
          value: "var(--color-primitive-pink-200)",
        },
        "300": {
          value: "var(--color-primitive-pink-300)",
        },
        "400": {
          value: "var(--color-primitive-pink-400)",
        },
        "500": {
          value: "var(--color-primitive-pink-500)",
        },
        "600": {
          value: "var(--color-primitive-pink-600)",
        },
        "700": {
          value: "var(--color-primitive-pink-700)",
        },
        "800": {
          value: "var(--color-primitive-pink-800)",
        },
        "900": {
          value: "var(--color-primitive-pink-900)",
        },
      },
      purple: {
        "50": {
          value: "var(--color-primitive-purple-50)",
        },
        "100": {
          value: "var(--color-primitive-purple-100)",
        },
        "200": {
          value: "var(--color-primitive-purple-200)",
        },
        "300": {
          value: "var(--color-primitive-purple-300)",
        },
        "400": {
          value: "var(--color-primitive-purple-400)",
        },
        "500": {
          value: "var(--color-primitive-purple-500)",
        },
        "600": {
          value: "var(--color-primitive-purple-600)",
        },
        "700": {
          value: "var(--color-primitive-purple-700)",
        },
        "800": {
          value: "var(--color-primitive-purple-800)",
        },
        "900": {
          value: "var(--color-primitive-purple-900)",
        },
      },
      blue: {
        "50": {
          value: "var(--color-primitive-blue-50)",
        },
        "100": {
          value: "var(--color-primitive-blue-100)",
        },
        "200": {
          value: "var(--color-primitive-blue-200)",
        },
        "300": {
          value: "var(--color-primitive-blue-300)",
        },
        "400": {
          value: "var(--color-primitive-blue-400)",
        },
        "500": {
          value: "var(--color-primitive-blue-500)",
        },
        "600": {
          value: "var(--color-primitive-blue-600)",
        },
        "700": {
          value: "var(--color-primitive-blue-700)",
        },
        "800": {
          value: "var(--color-primitive-blue-800)",
        },
        "900": {
          value: "var(--color-primitive-blue-900)",
        },
      },
      green: {
        "50": {
          value: "var(--color-primitive-green-50)",
        },
        "100": {
          value: "var(--color-primitive-green-100)",
        },
        "200": {
          value: "var(--color-primitive-green-200)",
        },
        "300": {
          value: "var(--color-primitive-green-300)",
        },
        "400": {
          value: "var(--color-primitive-green-400)",
        },
        "500": {
          value: "var(--color-primitive-green-500)",
        },
        "600": {
          value: "var(--color-primitive-green-600)",
        },
        "700": {
          value: "var(--color-primitive-green-700)",
        },
        "800": {
          value: "var(--color-primitive-green-800)",
        },
        "900": {
          value: "var(--color-primitive-green-900)",
        },
      },
      orange: {
        "50": {
          value: "var(--color-primitive-orange-50)",
        },
        "100": {
          value: "var(--color-primitive-orange-100)",
        },
        "200": {
          value: "var(--color-primitive-orange-200)",
        },
        "300": {
          value: "var(--color-primitive-orange-300)",
        },
        "400": {
          value: "var(--color-primitive-orange-400)",
        },
        "500": {
          value: "var(--color-primitive-orange-500)",
        },
        "600": {
          value: "var(--color-primitive-orange-600)",
        },
        "700": {
          value: "var(--color-primitive-orange-700)",
        },
        "800": {
          value: "var(--color-primitive-orange-800)",
        },
        "900": {
          value: "var(--color-primitive-orange-900)",
        },
      },
      red: {
        "50": {
          value: "var(--color-primitive-red-50)",
        },
        "100": {
          value: "var(--color-primitive-red-100)",
        },
        "200": {
          value: "var(--color-primitive-red-200)",
        },
        "300": {
          value: "var(--color-primitive-red-300)",
        },
        "400": {
          value: "var(--color-primitive-red-400)",
        },
        "500": {
          value: "var(--color-primitive-red-500)",
        },
        "600": {
          value: "var(--color-primitive-red-600)",
        },
        "700": {
          value: "var(--color-primitive-red-700)",
        },
        "800": {
          value: "var(--color-primitive-red-800)",
        },
        "900": {
          value: "var(--color-primitive-red-900)",
        },
      },
    },
    focusOutline: {
      light: {
        value: "var(--color-focusOutline-light)",
      },
      value: "var(--color-focusOutline)",
    },
    button: {
      primary: {
        comment: "Background of primary buttons",
        text: {
          comment: "Accessible color on Primary Button",
          value: "var(--color-button-primary-text)",
        },
        hovered: {
          comment: "Background of primary button hovered state",
          value: "var(--color-button-primary-hovered)",
        },
        pressed: {
          comment: "Background of primary button pressed state",
          value: "var(--color-button-primary-pressed)",
        },
        focused: {
          comment: "Background of primary button focused state",
          value: "var(--color-button-primary-focused)",
        },
        disabled: {
          comment: "Background of primary button disabled state",
          text: {
            comment: "Accessible color on primary button disabled state",
            value: "var(--color-button-primary-disabled-text)",
          },
          value: "var(--color-button-primary-disabled)",
        },
        value: "var(--color-button-primary)",
      },
      auxiliary: {
        comment: "Background of auxiliary buttons",
        inverse: {
          value: "var(--color-button-auxiliary-inverse)",
        },
        text: {
          comment: "Accessible color on auxiliary Button",
          inverse: {
            value: "var(--color-button-auxiliary-text-inverse)",
          },
          value: "var(--color-button-auxiliary-text)",
        },
        hovered: {
          comment: "Background of auxiliary button hovered state",
          inverse: {
            value: "var(--color-button-auxiliary-hovered-inverse)",
          },
          value: "var(--color-button-auxiliary-hovered)",
        },
        pressed: {
          comment: "Background of auxiliary button pressed state",
          inverse: {
            value: "var(--color-button-auxiliary-pressed-inverse)",
          },
          value: "var(--color-button-auxiliary-pressed)",
        },
        focused: {
          comment: "Background of auxiliary button focused state",
          inverse: {
            value: "var(--color-button-auxiliary-focused-inverse)",
          },
          value: "var(--color-button-auxiliary-focused)",
        },
        disabled: {
          comment: "Background of auxiliary button pressed state",
          inverse: {
            value: "var(--color-button-auxiliary-disabled-inverse)",
          },
          text: {
            comment: "Accessible color on auxiliary button disabled state",
            inverse: {
              value: "var(--color-button-auxiliary-disabled-text-inverse)",
            },
            value: "var(--color-button-auxiliary-disabled-text)",
          },
          value: "var(--color-button-auxiliary-disabled)",
        },
        value: "var(--color-button-auxiliary)",
      },
      secondary: {
        comment: "Background of secondary buttons",
        inverse: {
          comment: "Dark mode secondary buttons",
          value: "var(--color-button-secondary-inverse)",
        },
        border: {
          comment: "Border of secondary buttons",
          inverse: {
            comment: "Dark mode secondary button border",
            value: "var(--color-button-secondary-border-inverse)",
          },
          value: "var(--color-button-secondary-border)",
        },
        text: {
          comment: "Accessible color on Secondary Button",
          inverse: {
            comment: "Accessible color on Secondary Inverse Button",
            value: "var(--color-button-secondary-text-inverse)",
          },
          value: "var(--color-button-secondary-text)",
        },
        hovered: {
          comment: "Background of secondary button hovered state",
          inverse: {
            comment: "Background of dark mode secondary button hovered state",
            value: "var(--color-button-secondary-hovered-inverse)",
          },
          border: {
            comment: "Border of secondary button hovered state",
            inverse: {
              comment: "Dark mode border of secondary button hovered state",
              value: "var(--color-button-secondary-hovered-border-inverse)",
            },
            value: "var(--color-button-secondary-hovered-border)",
          },
          value: "var(--color-button-secondary-hovered)",
        },
        pressed: {
          comment: "Background of secondary button pressed state",
          inverse: {
            comment: "Background of dark mode secondary button pressed state",
            value: "var(--color-button-secondary-pressed-inverse)",
          },
          border: {
            comment: "Border of secondary button pressed state",
            inverse: {
              comment: "Dark mode border of secondary button pressed state",
              value: "var(--color-button-secondary-pressed-border-inverse)",
            },
            value: "var(--color-button-secondary-pressed-border)",
          },
          value: "var(--color-button-secondary-pressed)",
        },
        focused: {
          comment: "Background of secondary button focused state",
          inverse: {
            comment: "Dark mode secondary button focused state",
            value: "var(--color-button-secondary-focused-inverse)",
          },
          border: {
            comment: "Border of secondary button focused state",
            inverse: {
              comment: "Dark mode border of secondary button focused state",
              value: "var(--color-button-secondary-focused-border-inverse)",
            },
            value: "var(--color-button-secondary-focused-border)",
          },
          value: "var(--color-button-secondary-focused)",
        },
        disabled: {
          comment: "Background of secondary button pressed state",
          inverse: {
            comment: "Dark mode background of secondary button pressed state",
            value: "var(--color-button-secondary-disabled-inverse)",
          },
          text: {
            comment: "Accessible color on primary button disabled state",
            inverse: {
              comment:
                "Dark mode accessible color on primary button disabled state",
              value: "var(--color-button-secondary-disabled-text-inverse)",
            },
            value: "var(--color-button-secondary-disabled-text)",
          },
          border: {
            comment: "Border of secondary button disabled state",
            inverse: {
              comment: "Dark mode border of secondary button disabled state",
              value: "var(--color-button-secondary-disabled-border-inverse)",
            },
            value: "var(--color-button-secondary-disabled-border)",
          },
          value: "var(--color-button-secondary-disabled)",
        },
        value: "var(--color-button-secondary)",
      },
      tertiary: {
        comment: "Background of tertiary buttons",
        text: {
          comment: "Accessible color on tertiary Button",
          value: "var(--color-button-tertiary-text)",
        },
        hovered: {
          comment: "Background of tertiary button hovered state",
          value: "var(--color-button-tertiary-hovered)",
        },
        pressed: {
          comment: "Background of tertiary button pressed state",
          value: "var(--color-button-tertiary-pressed)",
        },
        focused: {
          comment: "Background of tertiary button focused state",
          value: "var(--color-button-tertiary-focused)",
        },
        disabled: {
          comment: "Background of tertiary button pressed state",
          text: {
            comment: "Accessible color on tertiary button disabled state",
            value: "var(--color-button-tertiary-disabled-text)",
          },
          value: "var(--color-button-tertiary-disabled)",
        },
        value: "var(--color-button-tertiary)",
      },
      subtle: {
        comment: "Background of subtle buttons",
        inverse: {
          value: "var(--color-button-subtle-inverse)",
        },
        text: {
          comment: "Accessible color on Subtle Button",
          inverse: {
            value: "var(--color-button-subtle-text-inverse)",
          },
          value: "var(--color-button-subtle-text)",
        },
        hovered: {
          comment: "Background of subtle button hovered state",
          inverse: {
            value: "var(--color-button-subtle-hovered-inverse)",
          },
          value: "var(--color-button-subtle-hovered)",
        },
        pressed: {
          comment: "Background of subtle button pressed state",
          inverse: {
            value: "var(--color-button-subtle-pressed-inverse)",
          },
          value: "var(--color-button-subtle-pressed)",
        },
        focused: {
          comment: "Background of subtle button focused state",
          inverse: {
            value: "var(--color-button-subtle-focused-inverse)",
          },
          value: "var(--color-button-subtle-focused)",
        },
        disabled: {
          comment: "Background of subtle button pressed state",
          inverse: {
            value: "var(--color-button-subtle-disabled-inverse)",
          },
          text: {
            comment: "Accessible color on subtle button disabled state",
            inverse: {
              value: "var(--color-button-subtle-disabled-text-inverse)",
            },
            value: "var(--color-button-subtle-disabled-text)",
          },
          value: "var(--color-button-subtle-disabled)",
        },
        value: "var(--color-button-subtle)",
      },
      warning: {
        comment: "Background of warning buttons",
        text: {
          comment: "Accessible color on Warning Button",
          value: "var(--color-button-warning-text)",
        },
        hovered: {
          comment: "Background of warning button hovered state",
          value: "var(--color-button-warning-hovered)",
        },
        pressed: {
          comment: "Background of warning button pressed state",
          value: "var(--color-button-warning-pressed)",
        },
        focused: {
          comment: "Background of warning button focused state",
          value: "var(--color-button-warning-focused)",
        },
        disabled: {
          comment: "Background of warning button pressed state",
          text: {
            comment: "Accessible color on warning button disabled state",
            value: "var(--color-button-warning-disabled-text)",
          },
          value: "var(--color-button-warning-disabled)",
        },
        value: "var(--color-button-warning)",
      },
      critical: {
        comment: "Background of critical buttons",
        text: {
          comment: "Accessible color on Critical Button",
          value: "var(--color-button-critical-text)",
        },
        hovered: {
          comment: "Background of critical button hovered state",
          value: "var(--color-button-critical-hovered)",
        },
        pressed: {
          comment: "Background of critical button pressed state",
          value: "var(--color-button-critical-pressed)",
        },
        focused: {
          comment: "Background of critical button focused state",
          value: "var(--color-button-critical-focused)",
        },
        disabled: {
          comment: "Background of critical button pressed state",
          text: {
            comment: "Accessible color on critical button disabled state",
            value: "var(--color-button-critical-disabled-text)",
          },
          value: "var(--color-button-critical-disabled)",
        },
        value: "var(--color-button-critical)",
      },
    },
    background: {
      primary: {
        comment: "Background for pages and cards",
        inverse: {
          comment: "Background for dark mode pages and cards",
          value: "var(--color-background-primary-inverse)",
        },
        value: "var(--color-background-primary)",
      },
      secondary: {
        comment: "Alternative background for pages",
        inverse: {
          comment: "Dark mode alternative background for pages",
          value: "var(--color-background-secondary-inverse)",
        },
        alpha: {
          comment:
            "Use on elements whose background should darken the background it is already on, such as zebra striped tables and disabled inputs",
          inverse: {
            comment:
              "Dark mode for elements whose background should lighten the background it is already on, such as zebra striped tables and disabled inputs",
            value: "var(--color-background-secondary-alpha-inverse)",
          },
          value: "var(--color-background-secondary-alpha)",
        },
        value: "var(--color-background-secondary)",
      },
      tertiary: {
        comment:
          "Background for elements that need a differentiating background on top of Primary Background",
        inverse: {
          comment:
            "Dark mode background for elements that need a differentiating background on top of Primary Background Inverse",
          value: "var(--color-background-tertiary-inverse)",
        },
        alpha: {
          comment:
            "Use on elements whose background should darken the background it is already on more than Background Secondary Alpha, such as chips and hover state for selectable elements",
          inverse: {
            comment:
              "Dark mode for elements whose background should lighten the background it is already on more than Background Secondary Alpha Inverse, such as chips and hover state for selectable elements",
            value: "var(--color-background-tertiary-alpha-inverse)",
          },
          value: "var(--color-background-tertiary-alpha)",
        },
        value: "var(--color-background-tertiary)",
      },
      selected: {
        comment: "Selected state background",
        inverse: {
          comment: "Dark mode selected state background",
          value: "var(--color-background-selected-inverse)",
        },
        light: {
          comment: "Subdued selected state background",
          inverse: {
            comment: "Dark mode subdued selected state background",
            value: "var(--color-background-selected-light-inverse)",
          },
          value: "var(--color-background-selected-light)",
        },
        value: "var(--color-background-selected)",
      },
      disabled: {
        comment: "Disabled state background",
        inverse: {
          comment: "Dark mode disabled state background",
          value: "var(--color-background-disabled-inverse)",
        },
        value: "var(--color-background-disabled)",
      },
      info: {
        comment: "Background for information elements",
        light: {
          comment: "Subdued background for information elements",
          inverse: {
            comment: "Dark mode subdued background for information elements",
            value: "var(--color-background-info-light-inverse)",
          },
          value: "var(--color-background-info-light)",
        },
        value: "var(--color-background-info)",
      },
      success: {
        comment: "Background for success elements",
        light: {
          comment: "Subdued background for success elements",
          inverse: {
            comment: "Dark mode subdued background for success elements",
            value: "var(--color-background-success-light-inverse)",
          },
          value: "var(--color-background-success-light)",
        },
        value: "var(--color-background-success)",
      },
      warning: {
        comment: "Background for warning elements",
        light: {
          comment: "Subdued background for warning elements",
          inverse: {
            comment: "Dark mode subdued background for warning elements",
            value: "var(--color-background-warning-light-inverse)",
          },
          value: "var(--color-background-warning-light)",
        },
        value: "var(--color-background-warning)",
      },
      critical: {
        comment: "Background for critical elements",
        light: {
          comment: "Subdued background for critical elements",
          inverse: {
            comment: "Dark mode subdued background for critical elements",
            value: "var(--color-background-critical-light-inverse)",
          },
          value: "var(--color-background-critical-light)",
        },
        value: "var(--color-background-critical)",
      },
      overlay: {
        comment: "Background for overlay elements",
        value: "var(--color-background-overlay)",
      },
    },
    border: {
      normal: {
        comment: "Default border color",
        inverse: {
          comment: "Dark mode default border color",
          value: "var(--color-border-normal-inverse)",
        },
        value: "var(--color-border-normal)",
      },
      light: {
        comment: "Subdued border color. Example: Thin lines in tables.",
        inverse: {
          comment: "Dark mode subdued border color",
          value: "var(--color-border-light-inverse)",
        },
        value: "var(--color-border-light)",
      },
      disabled: {
        comment: "Disabled border color",
        value: "var(--color-border-disabled)",
      },
      selected: {
        comment: "Selected border color",
        light: {
          comment: "Subdued border color",
          value: "var(--color-border-selected-light)",
        },
        inverse: {
          comment: "Dark mode selected border color",
          value: "var(--color-border-selected-inverse)",
        },
        value: "var(--color-border-selected)",
      },
      info: {
        comment: "Information border color",
        light: {
          comment: "Subdued information border color",
          inverse: {
            comment: "Dark mode subdued information border color",
            value: "var(--color-border-info-light-inverse)",
          },
          value: "var(--color-border-info-light)",
        },
        value: "var(--color-border-info)",
      },
      success: {
        comment: "Success border color",
        light: {
          comment: "Subdued success border color",
          inverse: {
            comment: "Dark mode subdued success border color",
            value: "var(--color-border-success-light-inverse)",
          },
          value: "var(--color-border-success-light)",
        },
        value: "var(--color-border-success)",
      },
      warning: {
        comment: "Warning border color",
        light: {
          comment: "Subdued warning border color",
          inverse: {
            comment: "Dark mode subdued warning border color",
            value: "var(--color-border-warning-light-inverse)",
          },
          value: "var(--color-border-warning-light)",
        },
        value: "var(--color-border-warning)",
      },
      critical: {
        comment: "Critical border color",
        light: {
          comment: "Subdued critical border color",
          inverse: {
            comment: "Dark mode subdued critical border color",
            value: "var(--color-border-critical-light-inverse)",
          },
          value: "var(--color-border-critical-light)",
        },
        value: "var(--color-border-critical)",
      },
    },
    brand: {
      DISQO: {
        comment: "DISQO brand color",
        value: "var(--color-brand-DISQO)",
      },
      SurveyJunkie: {
        comment: "Survey Junkie brand color",
        value: "var(--color-brand-SurveyJunkie)",
      },
    },
    dataViz: {
      categorical: {
        "1": {
          value: "var(--color-dataViz-categorical-1)",
        },
        "2": {
          value: "var(--color-dataViz-categorical-2)",
        },
        "3": {
          value: "var(--color-dataViz-categorical-3)",
        },
        "4": {
          value: "var(--color-dataViz-categorical-4)",
        },
        "5": {
          value: "var(--color-dataViz-categorical-5)",
        },
        "6": {
          value: "var(--color-dataViz-categorical-6)",
        },
        "7": {
          value: "var(--color-dataViz-categorical-7)",
        },
        "8": {
          value: "var(--color-dataViz-categorical-8)",
        },
        "9": {
          value: "var(--color-dataViz-categorical-9)",
        },
        "10": {
          value: "var(--color-dataViz-categorical-10)",
        },
        "11": {
          value: "var(--color-dataViz-categorical-11)",
        },
        "12": {
          value: "var(--color-dataViz-categorical-12)",
        },
      },
      categoricalSubdued: {
        "1": {
          value: "var(--color-dataViz-categoricalSubdued-1)",
        },
        "2": {
          value: "var(--color-dataViz-categoricalSubdued-2)",
        },
        "3": {
          value: "var(--color-dataViz-categoricalSubdued-3)",
        },
        "4": {
          value: "var(--color-dataViz-categoricalSubdued-4)",
        },
        "5": {
          value: "var(--color-dataViz-categoricalSubdued-5)",
        },
        "6": {
          value: "var(--color-dataViz-categoricalSubdued-6)",
        },
      },
      likert: {
        "1": {
          value: "var(--color-dataViz-likert-1)",
        },
        "2": {
          value: "var(--color-dataViz-likert-2)",
        },
        "3": {
          value: "var(--color-dataViz-likert-3)",
        },
        "4": {
          value: "var(--color-dataViz-likert-4)",
        },
        "5": {
          value: "var(--color-dataViz-likert-5)",
        },
      },
      sequential: {
        "1": {
          value: "var(--color-dataViz-sequential-1)",
        },
        "2": {
          value: "var(--color-dataViz-sequential-2)",
        },
        "3": {
          value: "var(--color-dataViz-sequential-3)",
        },
        "4": {
          value: "var(--color-dataViz-sequential-4)",
        },
        "5": {
          value: "var(--color-dataViz-sequential-5)",
        },
        "6": {
          value: "var(--color-dataViz-sequential-6)",
        },
        "7": {
          value: "var(--color-dataViz-sequential-7)",
        },
        "8": {
          value: "var(--color-dataViz-sequential-8)",
        },
        "9": {
          value: "var(--color-dataViz-sequential-9)",
        },
        "10": {
          value: "var(--color-dataViz-sequential-10)",
        },
        "11": {
          value: "var(--color-dataViz-sequential-11)",
        },
        "12": {
          value: "var(--color-dataViz-sequential-12)",
        },
        "13": {
          value: "var(--color-dataViz-sequential-13)",
        },
        "14": {
          value: "var(--color-dataViz-sequential-14)",
        },
        "15": {
          value: "var(--color-dataViz-sequential-15)",
        },
        "16": {
          value: "var(--color-dataViz-sequential-16)",
        },
        gradient: {
          value: "var(--color-dataViz-sequential-gradient)",
        },
      },
    },
    text: {
      normal: {
        comment: "Default text color",
        inverse: {
          comment: "Dark mode default text color",
          value: "var(--color-text-normal-inverse)",
        },
        value: "var(--color-text-normal)",
      },
      title: {
        comment: "Default text color",
        inverse: {
          comment: "Dark mode default text color",
          value: "var(--color-text-title-inverse)",
        },
        value: "var(--color-text-title)",
      },
      secondary: {
        comment: "Secondary text color",
        inverse: {
          comment: "Dark mode secondary text color",
          value: "var(--color-text-secondary-inverse)",
        },
        value: "var(--color-text-secondary)",
      },
      placeholder: {
        comment: "Accessible placeholder text color",
        inverse: {
          comment: "Dark mode accessible text color",
          value: "var(--color-text-placeholder-inverse)",
        },
        value: "var(--color-text-placeholder)",
      },
      disabled: {
        comment: "Accessible disabled text color",
        inverse: {
          comment: "Dark mode accessible disabled text color",
          value: "var(--color-text-disabled-inverse)",
        },
        value: "var(--color-text-disabled)",
      },
      success: {
        comment: "Success text color",
        inverse: {
          comment: "Dark mode success color",
          value: "var(--color-text-success-inverse)",
        },
        value: "var(--color-text-success)",
      },
      warning: {
        comment: "Warning text color",
        inverse: {
          comment: "Dark mode warning text color",
          value: "var(--color-text-warning-inverse)",
        },
        value: "var(--color-text-warning)",
      },
      critical: {
        comment: "Critical text color",
        inverse: {
          comment: "Dark mode critical text color",
          value: "var(--color-text-critical-inverse)",
        },
        value: "var(--color-text-critical)",
      },
      onSuccess: {
        comment: "Accessible color on Success Background",
        value: "var(--color-text-onSuccess)",
      },
      onWarning: {
        comment: "Accessible color on Warning Background",
        value: "var(--color-text-onWarning)",
      },
      onCritical: {
        comment: "Accessible color on Critical Background",
        value: "var(--color-text-onCritical)",
      },
      onSelected: {
        comment: "Accessible color on Selected Background",
        inverse: {
          comment: "Accessible color on Selected Inverse Background",
          value: "var(--color-text-onSelected-inverse)",
        },
        value: "var(--color-text-onSelected)",
      },
      link: {
        comment: "Link color",
        inverse: {
          comment: "Dark mode link color",
          value: "var(--color-text-link-inverse)",
        },
        hovered: {
          comment: "Hover state link color",
          inverse: {
            comment: "Dark mode hover state link color",
            value: "var(--color-text-link-hovered-inverse)",
          },
          value: "var(--color-text-link-hovered)",
        },
        pressed: {
          comment: "Pressed state link color",
          inverse: {
            comment: "Dark mode pressed state link color",
            value: "var(--color-text-link-pressed-inverse)",
          },
          value: "var(--color-text-link-pressed)",
        },
        visited: {
          comment: "Visited link color",
          inverse: {
            comment: "Dark mode visited link color",
            value: "var(--color-text-link-visited-inverse)",
          },
          value: "var(--color-text-link-visited)",
        },
        value: "var(--color-text-link)",
      },
    },
  },
  focus: {
    shadow: {
      value: "var(--focus-shadow)",
    },
  },
  shadow: {
    none: {
      comment:
        "Used for when no shadow is needed. This token exists for components that support different shadows. It is not needed otherwise.",
      value: "var(--shadow-none)",
    },
    xs: {
      comment: "Used for hover state of inputs.",
      value: "var(--shadow-xs)",
    },
    sm: {
      comment:
        "Used for cards in active state and other elements like popovers and tooltips.",
      value: "var(--shadow-sm)",
    },
    md: {
      comment: "Used for active dropdown menus.",
      value: "var(--shadow-md)",
    },
    lg: {
      comment: "Used for dialogs and modals.",
      value: "var(--shadow-lg)",
    },
  },
  spacing: {
    "0": {
      comment: "Used for no spacing.",
      value: "var(--spacing-0)",
    },
    "1px": {
      comment: "Used for slight nudge.",
      value: "var(--spacing-1px)",
    },
    "2px": {
      comment: "Used for spacing within a component.",
      value: "var(--spacing-2px)",
    },
    "4px": {
      comment: "Used for spacing within a component.",
      value: "var(--spacing-4px)",
    },
    xs: {
      comment:
        "Used to separate related elements and for small padding or text and a related icon.",
      value: "var(--spacing-xs)",
    },
    sm: {
      comment:
        "Used only for right and left padding of form elements and horizontal tabs",
      value: "var(--spacing-sm)",
    },
    md: {
      comment:
        "Used to separate unrelated elements or groups and for normal padding.",
      value: "var(--spacing-md)",
    },
    lg: {
      comment: "Used to separate sub-sections of content.",
      value: "var(--spacing-lg)",
    },
    xl: {
      comment: "Used to separate sections of content.",
      value: "var(--spacing-xl)",
    },
    "2xl": {
      comment: "Used when more generous white space is needed.",
      value: "var(--spacing-2xl)",
    },
    "3xl": {
      comment: "Used when more extra generous white space is needed.",
      value: "var(--spacing-3xl)",
    },
  },
  text: {
    primitives: {
      fontFamilies: {
        paragraph: {
          value: "var(--text-primitives-fontFamilies-paragraph)",
        },
        heading: {
          value: "var(--text-primitives-fontFamilies-heading)",
        },
        number: {
          value: "var(--text-primitives-fontFamilies-number)",
        },
      },
      lineHeights: {
        none: {
          value: "var(--text-primitives-lineHeights-none)",
        },
        sm: {
          value: "var(--text-primitives-lineHeights-sm)",
        },
        md: {
          value: "var(--text-primitives-lineHeights-md)",
        },
      },
      fontWeights: {
        regular: {
          value: "var(--text-primitives-fontWeights-regular)",
        },
        bold: {
          value: "var(--text-primitives-fontWeights-bold)",
        },
        black: {
          value: "var(--text-primitives-fontWeights-black)",
        },
      },
      fontSize: {
        "0": {
          value: "var(--text-primitives-fontSize-0)",
        },
        "1": {
          value: "var(--text-primitives-fontSize-1)",
        },
        "2": {
          value: "var(--text-primitives-fontSize-2)",
        },
        "3": {
          value: "var(--text-primitives-fontSize-3)",
        },
        "4": {
          value: "var(--text-primitives-fontSize-4)",
        },
        "5": {
          value: "var(--text-primitives-fontSize-5)",
        },
        "6": {
          value: "var(--text-primitives-fontSize-6)",
        },
        "7": {
          value: "var(--text-primitives-fontSize-7)",
        },
        "8": {
          value: "var(--text-primitives-fontSize-8)",
        },
        "-2": {
          value: "var(--text-primitives-fontSize--2)",
        },
        "-1": {
          value: "var(--text-primitives-fontSize--1)",
        },
      },
      letterSpacing: {
        normal: {
          value: "var(--text-primitives-letterSpacing-normal)",
        },
        wide: {
          value: "var(--text-primitives-letterSpacing-wide)",
        },
      },
      paragraphSpacing: {
        "0": {
          value: "var(--text-primitives-paragraphSpacing-0)",
        },
        "1": {
          value: "var(--text-primitives-paragraphSpacing-1)",
        },
      },
    },
    display: {
      fontFamily: {
        value: "var(--text-display-fontFamily)",
      },
      fontWeight: {
        value: "var(--text-display-fontWeight)",
      },
      lineHeight: {
        value: "var(--text-display-lineHeight)",
      },
      paragraphSpacing: {
        value: "var(--text-display-paragraphSpacing)",
      },
      lg: {
        value: "var(--text-display-lg)",
      },
      md: {
        value: "var(--text-display-md)",
      },
      sm: {
        value: "var(--text-display-sm)",
      },
      xs: {
        value: "var(--text-display-xs)",
      },
    },
    headline: {
      fontFamily: {
        value: "var(--text-headline-fontFamily)",
      },
      fontWeight: {
        value: "var(--text-headline-fontWeight)",
      },
      lineHeight: {
        value: "var(--text-headline-lineHeight)",
      },
      paragraphSpacing: {
        value: "var(--text-headline-paragraphSpacing)",
      },
      xl: {
        value: "var(--text-headline-xl)",
      },
      lg: {
        value: "var(--text-headline-lg)",
      },
      md: {
        value: "var(--text-headline-md)",
      },
      sm: {
        value: "var(--text-headline-sm)",
      },
      xs: {
        value: "var(--text-headline-xs)",
      },
    },
    label: {
      fontFamily: {
        value: "var(--text-label-fontFamily)",
      },
      fontWeight: {
        value: "var(--text-label-fontWeight)",
      },
      lineHeight: {
        value: "var(--text-label-lineHeight)",
      },
      paragraphSpacing: {
        value: "var(--text-label-paragraphSpacing)",
      },
      lg: {
        value: "var(--text-label-lg)",
      },
      md: {
        value: "var(--text-label-md)",
      },
      sm: {
        value: "var(--text-label-sm)",
      },
      uppercase: {
        letterSpacing: {
          value: "var(--text-label-uppercase-letterSpacing)",
        },
        textCase: {
          value: "var(--text-label-uppercase-textCase)",
        },
      },
    },
    paragraph: {
      fontFamily: {
        value: "var(--text-paragraph-fontFamily)",
      },
      fontWeight: {
        value: "var(--text-paragraph-fontWeight)",
      },
      lineHeight: {
        value: "var(--text-paragraph-lineHeight)",
      },
      paragraphSpacing: {
        value: "var(--text-paragraph-paragraphSpacing)",
      },
      lg: {
        value: "var(--text-paragraph-lg)",
      },
      md: {
        value: "var(--text-paragraph-md)",
      },
      sm: {
        value: "var(--text-paragraph-sm)",
      },
    },
    bold: {
      fontWeight: {
        value: "var(--text-bold-fontWeight)",
      },
    },
    number: {
      fontFamily: {
        value: "var(--text-number-fontFamily)",
      },
    },
  },
  zIndex: {
    modal: {
      comment: "Used for modals.",
      value: "var(--zIndex-modal)",
    },
    dropdown: {
      comment: "Used for dropdowns.",
      value: "var(--zIndex-dropdown)",
    },
    toast: {
      comment: "Used for toast notifications.",
      value: "var(--zIndex-toast)",
    },
    tooltip: {
      comment: "Used for tooltips.",
      value: "var(--zIndex-tooltip)",
    },
  },
};
